























import { Component, Prop } from 'vue-property-decorator';
import { CLIENT_NAMES } from './constant';
import { LinkType } from './types';
import { envCongif } from '../../shared/env.config';
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import MysonicwallInfo from './my-sonicwall-info.vue';
const cssPrefix: string = 'mswLinks';
@Component({
  components: {
    MysonicwallInfo,
  },
})
export default class MswLinks extends SwExtendedVue {
  cssPrefix = cssPrefix;

  showMySonicwallInfo: boolean = false;

  @Prop({ type: String, default: CLIENT_NAMES.MYSONICWALL, required: true })
  clientName: any;

  mswLinks: LinkType[] = [
    {
      title: this.$t('login.link1')
        .toString(),
      text: this.$t('login.link1Text')
        .toString(),
      color: '#48B5C3',
      href: 'browserreq',
    },
    {
      title: this.$t('login.link2')
        .toString(),
      text: this.$t('login.link2Text')
        .toString(),
      color: '#C68DBA',
      href: 'https://www.sonicwall.com/en-us/products/management-and-reporting/capture-security-center',
    },
    {
      title: this.$t('login.link3')
        .toString(),
      text: this.$t('login.link3Text')
        .toString(),
      color: '#BADB77',
      href: 'https://securitycenter.sonicwall.com',
    },
  ];

  spoglinks: LinkType[] = [
    {
      title: 'What is Capture Security Center?',
      text: 'Simplify your security with single pane of glass',
      color: '#48B5C3',
      href: 'browserreq',
    },
    {
      title: 'Partner with Capture Security Center',
      text: 'Reduce operating expenses while increasing service agility by partnering with Capture Cloud',
      color: '#C68DBA',
      href: 'https://www.sonicwall.com/en-us/products/management-and-reporting/capture-security-center',
    },
    {
      title: 'Capture Security Center Live Demo',
      text: 'Learn more about capture cloud by watching the live demo',
      color: '#BADB77',
      href: `${envCongif.spog_url}/muir/spog/login?showdemo=yes`,
    },
  ];

  openUrl(url: string) {
    if (url === 'browserreq') {
      this.showMySonicwallInfo = true;
    } else {
      window.open(url, '_blank');
    }
  }

  get currentClientName() {
    return this.clientName;
  }

  get getLinks() {
    return this.clientName === CLIENT_NAMES.MYSONICWALL ? this.mswLinks : this.spoglinks;
  }
}
